Vue.component('navbar-element', {
	template: '<nav class="navbar navbar-white navbar-fixed-top">    <div class="container-fluid full-height">        <div class="row full-height ">            <div class="full-height navbar-container col-12">                <div class="navbar-item-left">                    <router-link :to="gridLocation" v-if="showGridButton">                        <div class="icon-grid-four"></div>                    </router-link>                </div>                <div class="navbar-header horizontal-center">{{ title }}                </div>                <div class="navbar-items-right">                    <div class="dropdown" v-if="showUserButton">                        <div data-toggle="dropdown" class="dropdown-toggle" aria-expanded="false">                            <span class="icon-user"></span>                        </div>                        <ul role="menu" class="dropdown-menu dropdown-menu-right full-width">                            <li class="dropdown-header">{{ \'statistic.user_menu.title\' | t}}</li>                            <li class="divider"></li>                            <li class="dropdown-item"><a @click="logoff">                                    {{ \'statistic.user_menu.logout\' | t }}                                </a>                            </li>                        </ul>                    </div>                </div>            </div>        </div>    </div></nav>',

	props: {
		title: {
			type: String,
			default: ""
		},
		showEditButton: {
			type: Boolean,
			default: false
		},
		showGridButton: {
			type: Boolean,
			default: true
		},
		showUserButton: {
			type: Boolean,
			default: true
		}
	},

	data: function () {
		return {
			gridLocation: '/',
			userInfo: session.getUser()
		}
	},
    methods: {
        logoff: function () {

            session.logout()
                .then(response => {
                    this.$router.replace({
                        name: "login"
                    });

                }).catch(error => {
                this.$message({
                    message: error.message,
                    type: "error"
                });
            });
        },
    },
	watch: {
	},
	computed: {
	}
});
